import { Typography } from '@breetometer/components';
import { type ILoginError, showToast } from 'BreetHelpers';
import { useLoginApi, useModalApi } from 'BreetHooks';
import { selectCredentials, selectLogin, useAppSelector } from 'BreetRedux';
import { useCallback, useState } from 'react';

import AvailableAccount from './AvailableAccount';

const Child = () => {
	const loginData = useAppSelector(selectLogin);

	const errorData = loginData.error as ILoginError | undefined;

	const credentials = useAppSelector(selectCredentials);

	const [selectedId, setSelectedId] = useState<string>('');

	const { isLoading, loginUser } = useLoginApi();

	const { handleModalClose } = useModalApi();

	const switchUserAccount = useCallback(
		(businessIdArg: string) => () => {
			if (!credentials?.email || !credentials.password) {
				showToast('error', 'Something went wrong');
				return;
			}

			setSelectedId(businessIdArg);

			loginUser({
				email: credentials.email,
				password: credentials.password,
				businessId: businessIdArg,
				onFinalCallback: handleModalClose('switchUserAccount'),
			});
		},
		[credentials?.email, credentials?.password, handleModalClose, loginUser]
	);

	return (
		<div className='available-accounts'>
			<Typography as='h4'>Available Accounts</Typography>
			<div className='list'>
				{errorData?.data.data.businesses.map((business) => (
					<AvailableAccount
						accountName={business.name}
						accountRole={business.role}
						onClick={switchUserAccount(business.id)}
						key={business.id}
						isLoading={selectedId === business.id && isLoading}
					/>
				))}
			</div>
		</div>
	);
};

export default Child;
